<template src="./MiniLoader.html"></template>
<script>
import Spinner from "@/partials/Spinner/Spinner.vue"
export default {
  name: "MiniLoader",
  components: {Spinner}
};
</script>
<style src="./MiniLoader.css"></style>
